/* eslint-disable */
/// <reference path="./useReduxState.d.ts" />

import { useReducer, useMemo } from 'react'
import { createStore } from 'redux'

export const MERGE = 'MERGE'
export const OVERWRITE = 'OVERWRITE'

/**
 * @type {UseReduxStateHook}
*/
const useReduxState = (initialState = {}) => {
	const reducer = (state = initialState, action) => {
		// Debug: verifica se state é inválido
		if (state && typeof state !== 'object') {
			console.error('useReduxState: Invalid state detected!', {
				state,
				typeOfState: typeof state,
				action,
				initialState
			})
		}
		
		// Garante que state sempre seja um objeto válido
		const safeState = (state && typeof state === 'object' && !Array.isArray(state)) ? state : initialState
		
		if (action.type === 'MERGE') {
			// Valida payload também
			if (action.payload && typeof action.payload !== 'object') {
				console.error('useReduxState: Invalid payload!', action.payload)
				return safeState
			}
			return { ...safeState, ...(action.payload || {}) }
		} else if (action.type === 'OVERWRITE') {
			// Valida payload do OVERWRITE
			if (action.payload && typeof action.payload !== 'object') {
				console.error('useReduxState: Invalid OVERWRITE payload!', action.payload)
				return safeState
			}
			return action.payload || safeState
		}
		return safeState
	}

	const [ , forceUpdate ] = useReducer((x) => x + 1, 0)
	const store = useMemo(() => createStore(reducer), [])

	const getState = () => {
		const state = store.getState()
		// Valida o estado retornado
		if (!state || typeof state !== 'object' || Array.isArray(state)) {
			console.error('useReduxState.getState: Invalid state!', state)
			return initialState
		}
		return state
	}
	
	const dispatch = (payload, type = MERGE) => {
		// Valida payload antes de dispatch
		if (payload && typeof payload !== 'object') {
			console.error('useReduxState.dispatch: Invalid payload!', { payload, type })
			return
		}
		
		const state = store.getState()
		store.dispatch({ type, payload })
		if (state !== store.getState()) {
			forceUpdate()
		}
	}

	const createFieldUpdater = (field) => (value) => dispatch({ [field]: value })

	return [ getState, dispatch, createFieldUpdater ]
}

export default useReduxState
